!(function (o, n, e) {
        const wsID = "cnvbd980iubn3dfghckg";
        const cID = "co3vik997i63hgp1hea0";
        const d = "3f74a716889024ddb76e.dirkkreuter.com";
        const cM = true;

		o.__cIDs = o.__cIDs || [];
		o.__cIDs.push(cID);
		o.__getcIDs = () => o.__cIDs;

		o[cID] = {
			ss: [
				{
					wsID,
					cID,
					d,
					a: true,
				},
			],
			ep: {
               facebookPixel: ["123514897487476"]
          },
          t: {
				project:
					new URL(window.location.href).hostname
						.split(".")
						.slice(-2, -1)[0] ?? "",
				host: document.location.host,
			},
			l: {
				ttl: 10,
				a: true,
				idpE: true,
				idpP: true,
			},
			cM,
		};

	function ls(n, d, s) {
		let promises = s.map((e) => {
			return new Promise((resolve, reject) => {
				let x = n.createElement("script");
				x.async = true;
				x.src = `https://${d}/cdn/scripts/${e}.js`;
				x.onload = resolve;
				x.onerror = reject;
				n.body.appendChild(x);
			});
		});
		return Promise.all(promises);
	}

	let x = n.createElement(e);
	x.async = true;
	x.src = `https://${d}/cdn/scripts/ot_b.js`;

	x.onload = function () {
		ls(n, d, ["ot_shopify"])
			.then(() => {
				window[window.__getcIDs()[0]].setConsent();
			})
			.catch((error) => {
				console.error("Failed to load some scripts:", error);
			});
	};

	let y = n.getElementsByTagName(e)[0];
	y.parentNode.insertBefore(x, y);
})(window, document, "script");